import React, { useEffect, useRef, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";
import { limitParagraphByCharLimit } from "../../Helper/Helper";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

const animationList = ["fadeInLeft", "fadeInRight"];

function TimelineDesign() {
  const [facilitiesData, setFacilitiesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const timelineSectionRef = useRef(null);

  useEffect(() => {
    getFacilitiesData();
  }, []);

  const getFacilitiesData = async () => {
    try {
      const response = await SendPostRequest("facilities");
      setFacilitiesData(response?.data || []);
    } catch (error) {
      console.error("Error fetching facilities:", error);
      setFacilitiesData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const animatedItems = entry.target.querySelectorAll("li.animated");
          animatedItems.forEach((item, index) => {
            setTimeout(() => {
              const animationType = item.getAttribute("data-animation");
              if (!item.classList.contains("visible")) {
                item.classList.add(animationType, "visible");
              }
            }, index * 300);
          });
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1,
    });

    if (timelineSectionRef.current) {
      observer.observe(timelineSectionRef.current);
    }

    return () => {
      if (timelineSectionRef.current) {
        observer.unobserve(timelineSectionRef.current);
      }
    };
  }, [facilitiesData]);

  return (
    <div className="page-wrapper-inner">
      <HeaderWrapper />
      <TextMainBannerWrapper Heading="Our Facilities" Image="theme-2-banner-facilities.webp"/>

      <div className="container">
        <div className="row mt-5">
          <div className="offset-md-2 col-md-8">
            <div className="title-wrap text-center">
              <div className="section-title margin-bottom-60">
                <h2 className="section-title mb-0 text-uppercase">
                  Provides Our <span className="theme-color">Best Facilities</span>
                </h2>
                <span className="section-border-bottom center"></span>
              </div>
            </div>
          </div>
        </div>

        {isLoading ? (
          <div
            style={{ minHeight: "300px" }}
            className="d-flex align-items-center justify-content-center"
          >
            <Spinner />
          </div>
        ) : facilitiesData.length === 0 ? (
          <div
            style={{ minHeight: "300px" }}
            className="d-flex align-items-center justify-content-center"
          >
            <h4>No Record Available</h4>
          </div>
        ) : (
          <div
            id="facilities-section"
            className="timeline-section pad-bottom-70"
            ref={timelineSectionRef}
          >
            <div className="timeline-wrapper">
              <ul className="timeline">
                {facilitiesData.map((facility, index) => (
                  <li
                    key={index}
                    className={`mb-5 animated ${
                      index % 2 === 1 ? "timeline-inverted" : ""
                    }`}
                    data-animation={animationList[index % 2]}
                     style={{ minHeight: "200px" }} 
                  >
                    <div className="timeline-image">
                      <div
                        className="img-circle first-fservices-img-wrapper"
                        style={{
                          backgroundImage: `url(${facility?.facility_image || "/assets/images/default.jpg"})`,
                        }}
                      />
                    </div>
                    <div className="timeline-panel">
                      <Link
                        to={`/facility/${facility?.facility_slug
                          ?.replaceAll(" ", "-")
                          ?.replaceAll("/", "-")}`}
                      >
                        <div className="timeline-heading">
                          <h4 className="timeline-title text-uppercase first-fservices-title">
                            {facility?.facility_title}
                          </h4>
                        </div>
                        <div
                          className="timeline-body"
                          dangerouslySetInnerHTML={{
                            __html:
                              limitParagraphByCharLimit(
                                facility?.facility_short_description,
                                190
                              ) + "...",
                          }}
                        />
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>

      <FooterWrapper />
    </div>
  );
}

export default TimelineDesign;
